import { IonSpinner } from "@ionic/react";
import React, { useEffect, useState } from "react";
import LimeAPI from "./LimeAPI";
import store, { actions } from "../store";

/**
 * HOC som hämtar projekt och kvalitetsdokument från URL-parametrarna
 * och populerar Redux innan sidan renderas.
 *
 * Gör att bakåt-navigation och djuplänkar fungerar korrekt även när
 * man landar direkt på t.ex. /projects/123/qualitydocument/456
 */
export default function withRouteData(ComposedComponent: React.ComponentType<any>) {
  return function RouteDataLoader(props: any) {
    const [ready, setReady] = useState(false);
    const { id, documentId } = props.match?.params || {};

    useEffect(() => {
      // Ingen :id i URL – rendera direkt
      if (!id) {
        setReady(true);
        return;
      }

      const abortController = new AbortController();

      async function loadData() {
        try {
          const state = store.getState();
          const projectId = parseInt(id, 10);

          // Hämta projekt om :id finns och inte matchar Redux
          if (projectId !== state.currentProject.id) {
            const project = await LimeAPI.get(
              `projects/${id}`,
              abortController.signal
            );
            store.dispatch(actions.currentProject.setCurrentProject(project));
          }

          // Hämta kvalitetsdokument om :documentId finns och inte matchar Redux
          if (documentId) {
            const docId = parseInt(documentId, 10);
            if (docId !== state.currentQualityDocument._id) {
              const doc = await LimeAPI.get(
                `qualitydocuments/${documentId}`,
                abortController.signal
              );
              store.dispatch(
                actions.currentQualityDocument.setQualityDocument(doc)
              );
            }
          }

          setReady(true);
        } catch {
          setReady(true);
        }
      }

      loadData();

      return () => {
        abortController.abort();
      };
    }, [id, documentId]);

    if (!ready) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <IonSpinner name="crescent" color="primary" />
        </div>
      );
    }

    return <ComposedComponent {...props} />;
  };
}
